import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/gtax/support/admin`;

const Thread = ({ s, h, reload }) => {
  const [text, setText] = useState("");
  const send = async (resolve) => {
    if (!text.trim()) return;
    try { await axios.post(`${API}/${s.sid}/reply`, { text, resolve }, h); setText(""); toast.success(s.email ? "Reply sent (also emailed)" : "Reply sent"); reload(); }
    catch { toast.error("Could not send"); }
  };
  return (
    <div className="gx-card p-5 space-y-3" data-testid={`gtax-support-thread-${s.sid}`}>
      <div className="flex flex-wrap justify-between gap-2 text-sm">
        <b>{s.name || "Visitor"} {s.email && <span className="font-normal text-[color:var(--mute)]">· {s.email}</span>} {s.reference && <span className="font-normal">· {s.reference}</span>}</b>
        <span className={s.status === "human" ? "text-[#A0523F] font-semibold" : "text-[color:var(--mute)]"}>{s.status === "human" ? "Needs a person" : "Handled automatically"}</span>
      </div>
      <div className="max-h-64 overflow-y-auto space-y-2 text-sm">
        {s.messages.map((m, i) => <p key={i} className={m.role === "user" ? "" : "text-[color:var(--mute)]"}><b>{m.role === "user" ? "Visitor" : m.by ? "You" : "Assistant"}:</b> {m.text}</p>)}
      </div>
      <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} placeholder="Type your reply…" className="w-full border border-[color:var(--line)] bg-transparent p-3 text-sm" data-testid={`gtax-support-reply-${s.sid}`} />
      <div className="flex gap-3">
        <button className="gx-btn !py-2" onClick={() => send(false)} data-testid={`gtax-support-send-${s.sid}`}>Reply</button>
        <button className="gx-ghost !py-2" onClick={() => send(true)} data-testid={`gtax-support-resolve-${s.sid}`}>Reply & hand back to assistant</button>
      </div>
    </div>
  );
};

export const SupportInbox = ({ h }) => {
  const [rows, setRows] = useState([]);
  const load = () => axios.get(`${API}/list`, h).then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); const id = setInterval(load, 20000); return () => clearInterval(id); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const waiting = rows.filter((r) => r.status === "human");
  return (
    <div data-testid="gtax-support-inbox">
      <h2 className="gx-serif text-3xl">Support chats ({waiting.length} need a person · {rows.length} total)</h2>
      <div className="mt-6 space-y-4">{[...waiting, ...rows.filter((r) => r.status !== "human").slice(0, 20)].map((s) => <Thread key={s.sid} s={s} h={h} reload={load} />)}</div>
    </div>
  );
};
